// extracted by mini-css-extract-plugin
export var actions = "_4n-0";
export var actionsContainer = "_4n-6";
export var border = "_4n-1";
export var childFullHeight = "_4n-d";
export var collapse = "_4n-2";
export var content = "_4n-8";
export var contentChild = "_4n-c";
export var fullscreen = "_4n-a";
export var hasLeftRadius = "_4n-h";
export var headerContainer = "_4n-3";
export var headerRow = "_4n-5";
export var hidePadding = "_4n-9";
export var navCollapsedGap = "_4n-i";
export var noScrollX = "_4n-j";
export var noScrollY = "_4n-k";
export var optOutTopPadding = "_4n-b";
export var pageMain = "_4n-g";
export var pageOuter = "_4n-e";
export var pagePadding = "_4n-7";
export var profile = "_4n-l";
export var profileContainer = "_4n-m";
export var profileImage = "_4n-n";
export var profileMain = "_4n-o";
export var profileSubtitle = "_4n-q";
export var profileTitle = "_4n-p";
export var showLeftPadding = "_4n-f";
export var tabsWrapper = "_4n-4";
export var title = "_4n-r";